/**
 * 런타임 데이터 로더.
 * 번들된 `src/data/*.json` 이 기본값이고, `public/data/*.json` 이 있으면 덮어쓴다.
 */

import { applyBalance } from './balance';
import { applyEquipment } from './equipment';
import { applyItems } from './items';
import { applyJobs } from './jobs';
import { applyMaps } from './maps';
import { applyMonsters } from './monsters';
import { applyNpcs } from './npcs';
import { applyQuests } from './quests';
import { applySkills } from './skills';
import { applyStatusTable } from './status';
import { applyAchievements } from './achievements';
import { applyTitles } from './titles';
import { applyWeapons } from './weapons';

const FILES = [
  'balance',
  'weapons',
  'status',
  'items',
  'monsters',
  'maps',
  'jobs',
  'skills',
  'npcs',
  'quests',
  'equipment',
  'titles',
  'achievements',
] as const;

export type DataSource = 'file' | 'bundled';

async function fetchJson(url: string): Promise<unknown | undefined> {
  try {
    const res = await fetch(url);
    if (!res.ok) return undefined;
    return (await res.json()) as unknown;
  } catch {
    return undefined;
  }
}

export async function hydrateGameData(): Promise<DataSource> {
  const base = `${import.meta.env.BASE_URL}data/`;
  const results = await Promise.all(FILES.map((name) => fetchJson(`${base}${name}.json`)));
  const found = results.filter((v) => v !== undefined).length;
  if (found === 0) return 'bundled';
  if (found !== FILES.length) {
    console.warn(`[data] public/data 가 ${found}/${FILES.length} 만 있어 번들 값을 유지합니다`);
    return 'bundled';
  }

  applyBalance(results[0]);
  applyWeapons(results[1]);
  applyStatusTable(results[2]);
  applyItems(results[3]);
  applyMonsters(results[4]);
  applyMaps(results[5]);
  applyJobs(results[6]);
  applySkills(results[7]);
  applyNpcs(results[8]);
  applyQuests(results[9]);
  applyEquipment(results[10]);
  applyTitles(results[11]);
  applyAchievements(results[12]);
  return 'file';
}
